// opacity texte au scroll
document.addEventListener("DOMContentLoaded", function () {

	  gsap.registerPlugin(ScrollTrigger);
  
	  const words = document.querySelectorAll('.mm-word-catchline');
  
	  words.forEach((word, index) => {

		gsap.fromTo(word,
		  { opacity: 0.2 },
		  {
			opacity: 1, 
			duration: 0.5, 
			scrollTrigger: {
			  trigger: word,
			  start: "top 80%",
			  end: "top 20%", 
			  scrub: true, 
			}
		  }
		);
	  });

  });